
/**
 * Module dependencies.
 */

import { Avatar, AvatarProps } from './avatar';
import { BackgroundImage } from 'react-components/media';
import { getAcronym } from '../../acronym';
import { useImageSources } from '../image-sources';

/**
 * `Props` type.
 */

type Props = Omit<AvatarProps, 'size'> & {
  imageUrl?: string | null | undefined;
  name: string;
  size?: AvatarProps['size'];
};

/**
 * Export `UserAvatar` component.
 */

export function UserAvatar(props: Props): JSX.Element {
  const { imageUrl, name, size, ...rest } = props;
  const imageSources = useImageSources(imageUrl, '128x');

  return (
    <Avatar
      {...rest}
      colorTheme={'gray'}
      size={size ?? 'medium'}
    >
      {imageSources ? <BackgroundImage {...imageSources} /> : getAcronym(name)}
    </Avatar>
  );
}
